module.exports = {
	declined: "The transaction was declined. Please use a different card or contact your bank.",
	insufficient_funds:
		"The transaction was declined due to insufficient funds in your account. Please use a different card or contact your bank.",
	temporary_hold:
		"Your card has a temporary hold. Please use a different card or contact your bank.",
	too_many_attempts:
		"The transaction was declined. You have exceeded a reasonable number of attempts. Please wait a while before retrying your card, or try a different card.",
	call_issuer:
		"Your transaction was declined. Please contact your bank for further details or try another card.",
	call_issuer_update_cardholder_data:
		"Please contact support: the payment system experienced an unspecified error with your card issuer.",
	paypal_primary_declined:
		"Your primary funding source was declined. Please try again or update your billing information with PayPal.",
	paypal_declined_use_alternate:
		"Your primary funding source was declined. Please try again to use your secondary funding source.",
	declined_security_code:
		"The security code you entered does not match. Please update the CVV and try again.",
	declined_exception: "The transaction was declined. Please try again or try another card.",
	declined_missing_data: "Your billing information is missing some required",
	invalid_data: "The transaction was declined due to invalid",
	invalid_email: "Your email address is not valid.",
	declined_card_number: "Your card number is not valid. Please update your card number.",
	invalid_card_number: "Your card number is not valid. Please update your card number.",
	invalid_account_number: "Your account number is not valid. Please update your account number.",
	declined_expiration_date: "Your expiration date is invalid or does not match.",
	gateway_token_not_found:
		"Your payment details were not found. Please update your billing information.",
	exceeds_daily_limit:
		"The transaction exceeds your daily approval limit. Please contact your bank or try another card.",
	invalid_merchant_type:
		"Your card is not allowed to complete this transaction. Please try another card.",
	invalid_transaction:
		"Your card is not allowed to complete this transaction. Please contact your bank or try another card.",
	invalid_issuer: "Your card number is not valid. Please try another card or contact your bank.",
	card_type_not_accepted: "Your card type is not accepted. Please try another card.",
	payment_not_accepted: "Your payment type is not accepted. Please try another card.",
	restricted_card:
		"Your card cannot be accepted. Please contact your issuing bank for details or try another card.",
	restricted_card_chargeback:
		"Your card cannot be accepted. Please contact your issuing bank for details or try another card.",
	card_not_activated:
		"Your card has not been activated. Please call your bank to activate your card and try again.",
	deposit_referenced_chargeback: "The refund cannot be processed because of a chargeback.",
	customer_canceled_transaction:
		"You canceled the transaction after it was approved. Please update your billing information to authorize a new transaction.",
	cardholder_requested_stop:
		"You requested recurring payments no longer be accepted on this card. Please update your billing information.",
	no_billing_information:
		"Your billing information is not on file. Please add your billing information.",
	paypal_invalid_billing_agreement:
		"Your PayPal billing agreement is no longer valid. Please update your billing information.",
	paypal_hard_decline:
		"Your primary funding source was declined. Please update your billing information with PayPal or try again.",
	paypal_account_issue:
		"Your primary funding source was declined. Please update your billing information with PayPal or try again.",
	fraud_address:
		"Your billing address does not match the address on your account. Please fix your address or contact your bank.",
	fraud_stolen_card:
		"The transaction was declined. Please use a different card or contact your bank.",
	fraud_ip_address: "The transaction was declined. Please contact support.",
	fraud_security_code:
		"The security code you entered does not match. Please update the CVV and try again.",
	expired_card: "Your credit card is expired, please update your card.",
	fraud_gateway: "The transaction was declined. Please use a different card or contact your bank.",
	fraud_too_many_attempts:
		"You attempted to use this card too many times. Please wait 15 minutes before trying again, or use a different card.",
	fraud_advanced_verification:
		"The transaction was declined. Please use a different card or contact your bank.",
	fraud_velocity: "The transaction was declined. Please contact support.",
	fraud_generic:
		"Please validate information and try again. If the problem persists, please contact your bank.",
	fraud_address_recurly:
		"Your billing address does not match the address on your account. Please fix your address or contact your bank.",
	fraud_risk_check:
		"Your billing address does not match the address on your account. Please fix your address or contact your bank.",
	fraud_manual_decision:
		"This transaction was declined because it appears to be a fraudulent attempt. Please try a different card.",
	invalid_gateway_configuration:
		"Please contact support: the payment system is configured incorrectly. Your card was not charged.",
	invalid_login:
		"Please contact support: the payment system is configured incorrectly. Your card was not charged.",
	gateway_unavailable:
		"Please contact support: the payment system experienced an unspecified error with your card issuer.",
	processor_unavailable:
		"Please contact support: the payment system experienced an unspecified error with your card issuer.",
	issuer_unavailable:
		"Please contact support: the payment system experienced an unspecified error with your card issuer.",
	gateway_timeout:
		"Please contact support: the payment system did not respond in time to process your transaction.",
	gateway_error: "An error occurred while processing your transaction. Please contact support.",
	contact_gateway:
		"Please contact support: the payment system experienced an unspecified error with your card issuer.",
	try_again: "The payment system would like you to please try again.",
	cvv_required:
		"Please contact support: the payment system experienced an error. Your card was not charged.",
	currency_not_supported:
		"Please contact support: the requested currency is not supported for this merchant. Your card was not charged.",
	ssl_error:
		"Please contact support: the payment system experienced an error. Your card was not charged.",
	zero_dollar_auth_not_supported:
		"Please contact support: the payment system experienced an error while authorizing your card. Your card was not charged.",
	no_gateway:
		"Please contact support: the payment system experienced an unspecified error with your card issuer.",
	ach_transactions_not_supported: "Please contact support: ACH/EFT transfers are not supported.",
	three_d_secure_not_supported:
		"Please contact support: the payment system experienced an error. Your card was not charged.",
	transaction_not_found: "The original transaction was not found.",
	transaction_settled:
		"The transaction has already been settled, so it cannot be voided. Please try a refund.",
	transaction_already_voided:
		"The transaction has already been voided, so it cannot be settled or refunded.",
	transaction_failed_to_settled:
		"The transaction did not settle successfully. Please update your billing information.",
	payment_cannot_void_authorization:
		"An error occurred while voiding your payment authorization. Please contact support.",
	partial_credits_not_supported:
		"An error occurred while refunding your transaction. Please contact support.",
	cannot_refund_unsettled_transactions:
		"An error occurred while refunding your transaction. Please contact support.",
	transaction_cannot_be_refunded: "The transaction cannot be refunded. Please contact support.",
	transaction_cannot_be_voided: "The transaction cannot be voided. Please contact support.",
	total_credit_exceeds_capture:
		"An error occurred while refunding your transaction. Please contact support.",
	authorization_expired:
		"An error occurred while processing your transaction. Please contact update your billing information.",
	authorization_already_captured:
		"An error occurred while processing your transaction. Please contact support.",
	authorization_amount_depleted:
		"An error occurred while processing your transaction. Please contact support.",
	recurly_error: "An error occurred while processing your transaction. Please contact support.",
	unknown:
		"The transaction was declined or failed for an unknown reason. Please try again or contact support.",
	api_error: "An error occurred while processing your transaction. Please contact support.",
	duplicate_transaction:
		"A similar transaction was recently submitted. Please wait a few minutes and try again.",
	recurly_failed_to_get_token:
		"An error occurred while initializing the transaction. Please try again.",
	recurly_token_not_found:
		"An error occurred while processing your transaction. Please contact support.",
	invalid_payment_method_hard:
		"Your transaction was declined. Please contact your bank for further details or try another card.",
	invalid_payment_method:
		"Your transaction was declined. Please contact your bank for further details or try another card.",
	amazon_declined_review:
		"Your card was declined. In order to resolve the issue, check your payment method in Amazon.",
	declined_saveable:
		"Your transaction was declined. Please contact your bank for further details or try another card.",
	CCNAME_REQUIRED: "Enter the name as shown on your card",
	CCNAME_MAX_LEN: "Your First Name or Last Name exceeds the limit of 50 symbols",
	PURCHASE_ERROR: "There was an unknown problem with the transaction",
};
